export const BOUNDARY_HIGHLIGHT_BOUNDARY_HOVER = 'BOUNDARY_HIGHLIGHT_BOUNDARY_HOVER';
export const BOUNDARY_HIGHLIGHT_BOUNDARY_STOP_HOVER = 'BOUNDARY_HIGHLIGHT_BOUNDARY_STOP_HOVER';
export const BOUNDARY_HIGHLIGHT_BOUNDARY_TERRITORY_HOVER = 'BOUNDARY_HIGHLIGHT_BOUNDARY_TERRITORY_HOVER';
export const BOUNDARY_HIGHLIGHT_BOUNDARY_TERRITORY_STOP_HOVER = 'BOUNDARY_HIGHLIGHT_BOUNDARY_TERRITORY_STOP_HOVER';
